import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import DashboardLayout from '@/components/layout/DashboardLayout';

export default function ConversationsTable() {
  const [timeRange, setTimeRange] = useState<'1h' | '24h' | '7d'>('24h');

  const { data: sessions, isLoading } = useQuery({
    queryKey: ['admin-health-convos', timeRange],
    queryFn: async () => {
      const now = Date.now();
      const map = { '1h': 1, '24h': 24, '7d': 24 * 7 };
      const since = new Date(now - map[timeRange] * 60 * 60 * 1000).toISOString();
      const { data } = await supabase
        .from('chat_sessions')
        .select('id, posit_id, session_type, updated_at, is_active')
        .gte('updated_at', since)
        .order('updated_at', { ascending: false })
        .limit(200);
      return data || [];
    },
  });

  return (
    <DashboardLayout title="Conversations" maxWidth="7xl">
      <div className="flex items-center justify-between mb-4">
        <Select value={timeRange} onValueChange={(v: any) => setTimeRange(v)}>
          <SelectTrigger className="w-40"><SelectValue placeholder="Range" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="1h">Last hour</SelectItem>
            <SelectItem value="24h">Last 24h</SelectItem>
            <SelectItem value="7d">Last 7d</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Posit</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Updated</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(sessions || []).map((s: any) => (
              <TableRow key={s.id}>
                <TableCell className="font-mono text-xs">{s.id}</TableCell>
                <TableCell className="font-mono text-xs">{s.posit_id}</TableCell>
                <TableCell>{s.session_type}</TableCell>
                <TableCell>{s.is_active ? 'Active' : 'Ended'}</TableCell>
                <TableCell>{new Date(s.updated_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {(!isLoading && (sessions || []).length === 0) && (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-muted-foreground">No conversations</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </DashboardLayout>
  );
}

